import { render, staticRenderFns } from "./CarrosselComponent.vue?vue&type=template&id=47f50eea&scoped=true&"
import script from "./CarrosselComponent.vue?vue&type=script&lang=js&"
export * from "./CarrosselComponent.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselComponent.vue?vue&type=style&index=0&id=47f50eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f50eea",
  null
  
)

export default component.exports